import * as S from './giftcard-balance.styles';

const GiftcardBalance = ({ cardAccountBalance }) => {
  return (
    <S.Balance variant="h3" component="p" data-testid="GiftcardBalance.Balance">
      {cardAccountBalance != null ? `$${cardAccountBalance}` : ''}
    </S.Balance>
  );
};

export default GiftcardBalance;
